module.exports = __webpack_public_path__ + "img/nutmeg_tokencreate.c1c9f19.png";